import styled from 'styled-components';
import breakpoints from '../breakpoints';

const Wrapper = styled.div`
    align-items: ${props => (props.alignItems ? props.alignItems : 'center')};
    background-color: ${({ backgroundColor }) => (backgroundColor || 'gray')};
    background-image: ${props => (props.backgroundImage ? `url(${props.backgroundImage})` : undefined)};
    background-position: center;
    display: flex;
    height: ${props => props.height || '600px'};
    justify-content: center;
    max-width: 1600px;
    margin: 0 auto;
    position: relative;
    width: 100%;
`;

const Content = styled.div`
    padding: 0 33px;
    text-align: center;
    width: 100%;

    @media ${breakpoints.medium} {
        padding: 0 33px;
    }
`;

const Subtext = styled.div`
    color: #FFFFFF;
    display: block;
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    margin: 20px auto 30px auto;
    max-width: 320px;
    @media ${breakpoints.medium} {
        max-width: 100%;
    }
`;

const SubtextNarrow = styled(Subtext)`
    @media ${breakpoints.medium} {
        max-width: 788px;
    }
`;

const HasAccount = styled.div`
    color: #FFFFFF;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    margin-top: 20px;
`;

export default {
    Wrapper,
    Content,
    Subtext,
    SubtextNarrow,
    HasAccount,
};
